import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNumber1Square: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconNumber1Square"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM11.4502 7.77246L9.2998 9.2373V11.0889L11.3389 9.71191H11.4502V16.2275H13.4463V7.77246H11.4502Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNumber1Square;
